const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_app/genre/$slug.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_app/genre/$slug")({
  loader: lazyFn($$splitLoaderImporter, 'loader')
});